import {
  getAuthCookieDomain,
  getAuthCookieName,
  getLegacyAuthCookieName,
} from "./cookie-domain";

export interface CookieDeletion {
  name: string;
  domain?: string;
}

function escapeRegExp(value: string): string {
  return value.replace(/[.*+?^${}()|[\]\\]/g, "\\$&");
}

function chunkPattern(baseName: string): RegExp {
  return new RegExp(`^${escapeRegExp(baseName)}(?:\\.\\d+|-code-verifier)?$`);
}

export function getStaleAuthCookieDeletions(
  presentNames: string[],
  host?: string | null,
): CookieDeletion[] {
  const domain = getAuthCookieDomain(host);
  const currentName = getAuthCookieName(host);
  const legacyName = getLegacyAuthCookieName();

  const legacyPattern = legacyName ? chunkPattern(legacyName) : null;
  const currentPattern = chunkPattern(currentName);
  const deletions: CookieDeletion[] = [];

  for (const name of new Set(presentNames)) {
    if (legacyPattern?.test(name)) {
      deletions.push({ name });
      if (domain) deletions.push({ name, domain });
      continue;
    }
    if (domain && currentPattern.test(name)) {
      deletions.push({ name });
    }
  }

  return deletions;
}

export function serializeCookieDeletion({
  name,
  domain,
}: CookieDeletion): string {
  return `${name}=; Path=/; Max-Age=0; SameSite=Lax${domain ? `; Domain=${domain}` : ""}`;
}

export function appendCookieDeletions(
  headers: Headers,
  deletions: CookieDeletion[],
): void {
  for (const deletion of deletions) {
    headers.append("Set-Cookie", serializeCookieDeletion(deletion));
  }
}

function parseCookieNames(cookieHeader: string): string[] {
  return cookieHeader
    .split(";")
    .map((part) => part.trim().split("=")[0] ?? "")
    .filter(Boolean);
}

let browserPurgeDone = false;

export function purgeStaleAuthCookiesInBrowser(): void {
  if (typeof window === "undefined" || browserPurgeDone) return;
  browserPurgeDone = true;

  const deletions = getStaleAuthCookieDeletions(
    parseCookieNames(window.document.cookie),
    window.location.host,
  );

  for (const deletion of deletions) {
    window.document.cookie = serializeCookieDeletion(deletion);
  }
}
